import { render } from "./BtnFiles.vue?vue&type=template&id=d21e0eec&ts=true&lang=pug"
import script from "./BtnFiles.vue?vue&type=script&setup=true&lang=ts"
export * from "./BtnFiles.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__